
export function cleanId(id) {
    return `${id}`
}